var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321316605"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_2150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.662109 0.49707H17.3322V15.9171H0.662109V0.49707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3386 0.49707H7.44739V6.76135H-2.67188V9.65257H7.44739V15.9168H10.3386V9.65257H20.4579V6.76135H10.3386V0.49707Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.1166 10.8882L20.457 13.8551V10.8882H15.1166ZM11.4062 10.8882L20.457 15.9164V14.4945L13.9657 10.8882H11.4062ZM18.0462 15.9164L11.4062 12.2272V15.9164H18.0462Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4062 10.8882L20.457 15.9164V14.4945L13.9657 10.8882H11.4062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.4062 10.8882L20.457 15.9164V14.4945L13.9657 10.8882H11.4062Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.40931 10.8882L-2.67188 13.1555V10.8882H1.40931ZM6.37891 11.5276V15.9164H-1.52031L6.37891 11.5276Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.8195 10.8882L-2.67188 14.4945V15.9164L6.37891 10.8882H3.8195Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.66852 5.52526L-2.67188 2.55833V5.52526H2.66852ZM6.37891 5.52526L-2.67188 0.49707V1.91892L3.8195 5.52526H6.37891ZM-0.26105 0.49707L6.37891 4.18627V0.49707H-0.26105Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.37891 5.52526L-2.67188 0.49707V1.91892L3.8195 5.52526H6.37891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.37891 5.52526L-2.67188 0.49707V1.91892L3.8195 5.52526H6.37891Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.3758 5.52531L20.457 3.25796V5.52531H16.3758ZM11.4062 4.8859V0.49707H19.3055L11.4062 4.8859Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.9657 5.52526L20.457 1.91892V0.49707L11.4062 5.52526H13.9657Z",
    fill: "#D80027"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_2150"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.662109,
    y: 0.49707,
    width: 16.6701,
    height: 15.42,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.ef7a547e0e76de42e195d9393d4d4626.svg";
export { ForwardRef as ReactComponent };